/**
 * Toast 타입 정의
 */

/**
 * Toast 메시지 타입
 */
export enum ToastType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
}

/**
 * Toast 위치
 */
export enum ToastPosition {
    TOP_LEFT = 'top-left',
    TOP_CENTER = 'top-center',
    TOP_RIGHT = 'top-right',
    BOTTOM_LEFT = 'bottom-left',
    BOTTOM_CENTER = 'bottom-center',
    BOTTOM_RIGHT = 'bottom-right',
}

/**
 * Toast 메시지 인터페이스
 */
export interface ToastMessage {
    id: string;
    type: ToastType;
    message: string;
    duration?: number;
    position?: ToastPosition;
}

/**
 * Toast 옵션
 */
export interface ToastOptions {
    type?: ToastType;
    duration?: number;
    position?: ToastPosition;
}
